import { reducer } from './reducer';
import { REDUCER_NAME } from './constants';
export { fetchCatalogueInfo } from './actions';
export { getCatalogueInfo, getCatalogueInfoApiProgress, getCatalogueInfoError, getServerRendered, } from './selector';
export { reducer, REDUCER_NAME };
export const catalogueInfoReducerObject = { [REDUCER_NAME]: reducer };
